/* assets/section-results.js
   Results / Studies — scroll-triggered fill animation
   When section enters viewport, adds .is-visible class
   to trigger CSS transition on circle progress fill.
*/
(function () {
  'use strict';

  function initSection(section) {
    if (section.dataset.rsObserved === '1') return;
    section.dataset.rsObserved = '1';

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, {
      threshold: 0.2,
      rootMargin: '0px 0px -10% 0px'
    });

    observer.observe(section);
  }

  function initAll() {
    var sections = document.querySelectorAll('.results-section');
    for (var i = 0; i < sections.length; i++) {
      initSection(sections[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  /* Shopify Theme Editor: section reloaded */
  document.addEventListener('shopify:section:load', function (e) {
    if (e.target && e.target.querySelector) {
      var section = e.target.querySelector('.results-section');
      if (section) {
        section.dataset.rsObserved = '';
        initSection(section);
      }
    }
  });
})();
